/* eslint-disable react/display-name */
import React, { useState } from "react"
import { useDispatch } from "react-redux"
import UserProfileFormDialog from "./UserProfileFormDialog"
import userProfileSlice from "./userProfileSlice"

const { actions: userProfile } = userProfileSlice

export default function withUserProfileDialogForm(Wrapper) {
  return (props) => {
    const dispatch = useDispatch()
    const [openFormDialog, setOpenFormDialog] = useState(false)
    const [profile, setProfile] = useState(undefined)

    const editProfile = (editedProfile) => {
      if (editedProfile) {
        setProfile(editedProfile)
      }
      setOpenFormDialog(true)
    }

    const closeDialog = () => {
      setOpenFormDialog(false)
      setProfile(undefined)
    }

    const handleSave = (values) => {
      if (values._id) {
        return dispatch(userProfile.update(values)).then(closeDialog)
      }
      return dispatch(userProfile.create(values)).then(closeDialog)
    }

    return (
      <>
        <Wrapper {...props} editProfile={editProfile} />

        <UserProfileFormDialog
          open={openFormDialog}
          close={closeDialog}
          handleSave={handleSave}
          profile={profile}
        />
      </>
    )
  }
}
